import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SocialLink, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';
// import OSCTagMobile from './OSCTagMobile';
import Nav from './Navigation/Nav';

const styles = css`
  font:300 17px/24px ${typography.Condensed};
  a, a:link, a:visited {
    font-weight:700;
    color:${colors.brand1};
  }
  .Footer_wrapper {
    padding: 0 0 60px 0;
  }
  .Footer_header {
    background:${colors.neutral};
    text-align:center;
    padding:20px 0;
  }
  .Footer_body {
    background:${colors.neutralLight};
    padding:20px 0;
    .Footer_body-content {
      display:flex;
      flex-flow:row nowrap;
      justify-content:center;
      @media (min-width: 992px) {
        justify-content:space-between;
      }
    }
  }
  .Footer_footer {
    padding:10px 0;
    opacity:.6;
    @media (min-width: 992px) {
      padding:10px 0;
    }
    .Footer_footer-content {
      display:flex;
      flex-flow:row wrap;
      justify-content:center;
    }
  }
  .Footer_copyright {
    display:inline-block;
  }
  .Footer_credit {
    display:inline-block;
  }
  .Footer_nav {
    display:none;
    @media (min-width: 992px) {
      display:flex;
      flex-flow:row nowrap;
      justify-content:flex-start;
    }

    .Footer_navMenuHeading {
      font-weight: 700;
    }

    .Footer_navMenu {
      display: none;
      padding:0 20px;
      margin:0;
      list-style: none;
      @media (min-width: 992px) {
        display: block;
        padding:0 40px 0 0;
        .Footer_navMenuItem {
          font-weight: 700;
          a {
            font-weight: 400;
          }
        }
      }
    }
  }
  .Footer_address {
    text-align:center;
    @media (min-width: 992px) {
      text-align:left;
    }
  }
  .Footer_logo {
    width:100%;
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
    padding:10px 0;
    @media (min-width: 768px) {
      justify-content:flex-start;
      width:33.33333%;
    }
    img {
      max-width: 100%;
      height:auto;
      margin:0 auto;
      @media (min-width: 768px) {
        margin:0;
      }
    }
  }
  .Footer_socialLinks {
    width:100%;
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
    padding: 0;
    text-align: center;
    @media (min-width: 768px) {
      width:33.33333%;
    }
    ul {
      width:100%;
      margin:0;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      li {
        display: inline-block;
        margin: 0 10px;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        a img {
          height: 20px;
          width: auto;
          filter: brightness(10%);
        }
      }
    }
  }
  .Footer_eho {
    width:100%;
    display:flex;
    flex-flow:row nowrap;
    justify-content:center;
    padding:10px 0;
    @media (min-width: 768px) {
      justify-content:flex-end;
      width:33.33333%;
    }
  }
  .Footer_ehoLogo {
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
  }
  .Footer_legal {
    background:${colors.white};
    text-align:center;
    padding:20px 0;
    p {
      font-size: 15px;
      margin: 0 0 15px;
      line-height: 1.2;
    }
  }
`;

function Footer({ builder, widget }) {
  return (
    <footer className={styles}>
      <div className="Footer_wrapper">
        <section className="Footer_header">
          <div className="container Footer_header-content">
            <div className="Footer_copyright">
              &copy;{(new Date()).getFullYear()} {get(builder, 'name')}. All Rights Reserved.&nbsp;
            </div>
            <div className="Footer_credit">
              Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a>.
            </div>
          </div>
        </section>
        <section className="Footer_body">
          <div className="container Footer_body-content">
            <Nav
              id="footer"
              className="Footer_nav"
              menuProps={{
                subMenuClassName: 'Footer_navMenu',
                headingClassName: 'Footer_navMenuHeading',
                itemClassName: 'Footer_navMenuItem',
              }}
            />
            <div className="Footer_address pr-5 pr-lg-3">
              <span><b>Building In</b></span>
              <ul className="list-unstyled">
                <li>Appling, GA</li>
                <li>Evans, GA</li>
                <li>Grovetown, GA</li>
                <li>Harlem, GA</li>
                <li>Martinez, GA</li>
              </ul>
            </div>
            <div className="Footer_address">
              <ul className="list-unstyled">
                <li><strong>{get(builder, 'name')}</strong></li>
                <li>{get(builder, 'address.streetAddress')}</li>
                <li>{get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}</li>
                {
                  get(builder, 'telephone') &&
                  <li>Phone: <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a></li>
                }
                {
                  get(builder, 'fax') &&
                  <li>Fax: <a href={`tel:${get(builder, 'fax').replace(/[^0-9]/g, '')}`}>{get(builder, 'fax').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a></li>
                }
              </ul>
              <ul className="list-unstyled">
                <li><Link name="privacy-policy">Privacy Policy</Link></li>
                <li><Link name="terms">Terms & Conditions</Link></li>
                <li><Link name="accessibility">Accessibility Assistance</Link></li>
              </ul>
            </div>
          </div>
        </section>
        <section className="Footer_footer">
          <div className="container Footer_footer-content">
            <div className="Footer_logo">
              <img src="/images/logo-black.svg" alt={get(builder, 'name')} width="120" />
            </div>
            <div className="Footer_socialLinks">
              <ul className="list-unstyled">
                {
                  get(builder, 'socialLinks', []).filter(v => v).map(link => (
                    <li key={link}>
                      <SocialLink url={link} />
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="Footer_eho">
              <img className="Footer_ehoLogo"src="/images/icon-equal-housing-black.svg" alt="Equal Opportunity Housing Logo" width="40" />
            </div>
          </div>
        </section>
        {
          get(widget, 'footer_content[0].disclaimer') &&
          <section className="Footer_legal">
            <div className="container Footer_legal-content" dangerouslySetInnerHTML={SanitizeHtml(get(widget, 'footer_content[0].disclaimer'))} />
          </section>
        }
      </div>
      {/* <OSCTagMobile /> */}
    </footer>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  widget: 'footer',
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js